import Modal from "../layout/Modal";
import Button from "../layout/Button";

// Substitui window.confirm (pedido do usuário) — duas variantes de
// conteúdo/urgência: sair sendo o último atendente com acesso desconecta a
// instância DE VERDADE do grupo no WhatsApp (irreversível), sair não sendo
// o último só tira a sua própria visão do grupo.
function LeaveGroupConfirmModal(props: {
  groupName: string;
  isLastMember: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      shown
      title={props.isLastMember ? "Sair do grupo — atenção" : "Sair do grupo"}
      onClose={props.onClose}
      className="w-[420px]"
    >
      {props.isLastMember ? (
        <div className="text-xs text-primary space-y-2">
          <p>
            Você é o <b>único atendente com acesso</b> a "{props.groupName}".
          </p>
          <p className="bg-red/10 text-red font-semibold rounded-10 px-3 py-2">
            Sair agora desconecta o WhatsApp do Voki desse grupo DE VERDADE — ninguém mais vai
            conseguir ver ou usar esse grupo depois, e não tem como desfazer.
          </p>
        </div>
      ) : (
        <p className="text-xs text-primary">
          Sair do grupo "{props.groupName}"? Você deixa de ver esse grupo; os outros atendentes
          com acesso continuam normalmente.
        </p>
      )}

      <div className="flex justify-end gap-2.5 mt-6">
        <Button outline color="gray" onClick={props.onClose}>
          Cancelar
        </Button>
        <Button color="red" onClick={props.onConfirm}>
          {props.isLastMember ? "Sair e desconectar" : "Sair do grupo"}
        </Button>
      </div>
    </Modal>
  );
}

export default LeaveGroupConfirmModal;
